// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1-tTh","title":"Images90_title__2RuZ_","images":"Images90_images__mlogn"};